import React, { Component } from 'react';
import { Segment, Popup, Header, Button, Table, Icon, Accordion, Grid, Checkbox, Message } from 'semantic-ui-react';
import accountAPI from '../../../../../../apiCalls/accountAPI'
import ReactToPrint from "react-to-print";
import PrintDaily from './printDaily'
import Confirm from '../confirm'
import { convertEpochToDate, convertNumberStringToDate } from '../../../../../../util/constants';
import { formatPronoun } from '../../../../../../util';
import { isEmpty, isEqual, isNull, get, isUndefined } from "lodash";
import { downloadInvoiceSignedUrl } from "../../../../../../apiCalls/MainFormRequests";
import UpdateStatementsModal from "./UpdateStatementsModal"
import StatusDetailModal from "./StatusDetailModal"
import EdiModal from './EdiModal';
import StatementModal from './StatementModal';

class PreDailyStatement extends Component {
  constructor() {
    super();
    this.state = {
      values: [],
      activeIndex: -1,
      disabled: {},
      loading: false,
      otherFees: [],
      tempPunNumber: "",
      tempPortCode: "",
      tempBusinessName: "",
      tempPunInfo: "",
      isACHCredit: false,
      direct: false,
      submitted: false,
      showUpdateStatementsModal: false,
      showStatusDetailsModal: false,
      selcetedEntriesIndex: [],
      selectEntryNumber: "",
      selectedImporter: "",
      modalOpen: false,
      ediMessage: [],
      statementConfirmModal: false,
      countryOfBusiness: "",
      errorCode: "",
      errorMsg: "",
      // countOfShipmentsWithoutReleaseDate:0
      // responseReceived: false,
      // isStatementChecked:false,
      // isDeleteStatement:false,
      // clickDetails:{},
      // statements:new Map(),

    }
    // this.handleCheck=this.handleCheck.bind(this)
    // this.handleDeleteStatementEnteries=this.handleDeleteStatementEnteries.bind(this)
    // this.cancelStatement=this.cancelStatement.bind(this)
  }

  confirmModal = () => {
    this.setState({ statementConfirmModal: true });
  }
  changeStateModal = () => {
    this.setState({ statementConfirmModal: false })
  }

  formatTotal = (duty, tax, add, cvd, other) => {
    let formatDuty = (parseFloat(duty) / 100)
    let formatTax = (parseFloat(tax) / 100)
    let formatAdd = (parseFloat(add) / 100)
    let formatCvd = (parseFloat(cvd) / 100)
    let formatOther = parseFloat(other)
    let total = parseFloat(formatDuty + formatTax + formatAdd + formatCvd + formatOther).toFixed(2)
    return (total)
  }

  calculateOtherFees = (array) => {
    let total = 0;
    if (array) {
      for (let i = 0; i < array.length; i++) {
        total = total + parseFloat(array[i].value)
      }
    }
    total = parseFloat(total / 100).toFixed(2)
    return total;
  }

  isEmpty = (obj) => {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  componentWillMount = () => {
    this.setState({ countryOfBusiness: get(this.props, "kxUser.userInfo.brokerAdditionalInfo.countryOfBusiness", ""), })
    const { cbpDailyData, authStatus } = this.props
    const { statementEntries } = cbpDailyData
    if (statementEntries) {
      let totals = []
      for (let i = 0; i < statementEntries.length; i++) {
        // let total= this.calculateOtherFees(statementEntries[i].fees)
        let total = statementEntries[i].fees && this.calculateOtherFees(statementEntries[i].fees) || 0
        totals.push(total)
      }
      this.setState({
        otherFees: totals,
      })
    }

    if (this.isEmpty(authStatus)) {
      this.setState({ submitted: false })
    } else if (!this.isEmpty(authStatus) && authStatus.reasonCode && authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_SENT") {
      this.setState({ submitted: true })
      // } else if (!this.isEmpty(authStatus) && authStatus.reasonCode && authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_NONE") {
      //   this.setState({  submitted: false })
      // }
    } else if (!this.isEmpty(authStatus) && !authStatus.acceptanceErrorCode) {
      this.setState({ submitted: false })
    } else if (authStatus.acceptanceErrorCode && (authStatus.acceptanceErrorCode === "A" || authStatus.acceptanceErrorCode === "Q11")) {
      this.setState({ accepted: true })
    } else if (authStatus.acceptanceErrorCode && authStatus.acceptanceErrorCode === "R") {
      this.setState({ rejected: true, errorMessage: authStatus.acceptanceErrorMessage })
    }

  }

  componentDidMount = () => {
    // console.log ("DID MOUNT")
    // const { cbpDailyData} = this.props
    // const {statementsKey,statementsValue}=this.state
    let { submitted } = this.state
    if (submitted) {
      this.setState({ fetchingStatus: true })
      // console.log("setTimeout1")
      setTimeout(this.getNewAuthStatus, 5000)
    }

    // console.log("!aaa",statementsKey,statementsValue) 


    document.querySelector(".section-container").scrollTop = 0;
  }



  componentDidUpdate = (prevProps) => {
    // console.log ("UPDATE")
    if (!isEqual(this.props.authStatus, prevProps.authStatus)) {
      const { cbpDailyData, authStatus } = this.props
      const { statementEntries } = cbpDailyData

      if (this.isEmpty(authStatus)) {
        this.setState({ submitted: false })
      } else if (!this.isEmpty(authStatus) && authStatus.reasonCode && authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_SENT") {
        this.setState({ submitted: true })
      } else if (!this.isEmpty(authStatus) && authStatus.reasonCode && authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_NONE") {
        this.setState({ submitted: false })
      }
      else if (!this.isEmpty(authStatus) && !authStatus.acceptanceErrorCode) {
        this.setState({ submitted: false })
      } else if (authStatus.acceptanceErrorCode && (authStatus.acceptanceErrorCode === "A" || authStatus.acceptanceErrorCode === "Q11")) {
        this.setState({ accepted: true })
      } else if (authStatus.acceptanceErrorCode && authStatus.acceptanceErrorCode === "R") {
        this.setState({ rejected: true, errorMessage: authStatus.acceptanceErrorMessage })
      }

    }


  }


  // componentDidUpdate(prevProps, prevState) {
  //   if(!isEqual(this.state.submitted, prevState.submitted)) {
  //     let { submitted} = this.state
  //     if ( submitted ) {
  //       this.setState({ fetchingStatus: true })
  //       setTimeout(this.getNewAuthStatus, 5000)
  //     }
  //   }
  // }

  getMonthDifference = (startDate, endDate) => {
    return (
      endDate.getMonth() -
      startDate.getMonth() +
      12 * (endDate.getFullYear() - startDate.getFullYear())
    );
  }

  handleClick = () => {
    const { cbpDailyIndex } = this.props
    const { activeIndex } = this.state
    const newIndex = activeIndex === cbpDailyIndex ? -1 : cbpDailyIndex
    //  if(newIndex===-1){
    //    this.setState({isDeleteStatement:false})
    //  }
    this.setState({ activeIndex: newIndex, responseReceived: false })
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  handleRemove = (e, { name, value }) => {
    if (value === 'remove') {
      this.setState({ [name]: true })
    }
  }


  handleAuthorize = async () => {
    this.setState({ submitLoading: true })
    accountAPI.cbpAuthorization(this.props.statementNumber, this.props.cbpDailyData.totalAmountDue, this.props.filerCode, this.state.tempPunNumber, this.state.tempPortCode)
      .then(response => {
        if (response.data.eventMessage.code === 200) {
          this.setState({ submitted: true, submitLoading: false, confirm: false, rejected: false, fetchingStatus: true })
          // setTimeout(this.getNewAuthStatus , 5000)
          // console.log("setTimeout2")
          setTimeout(async () => {
            await this.getNewAuthStatus();
            await this.props.getStatementData();
          }, 5000)
          if (response.data.eventMessage.punNumber) {
            this.props.setPun(response.data.eventMessage.punNumber, this.props.cbpDailyIndex)
          }
        } else {
          this.setState({ submitLoading: false, rejected: false, submissionErr: true, confirm: false })
        }
      })
  }

  ediResponse = (statementNo, reasonCode) => {
    // console.log("statementNo", statementNo);
    // console.log("reasonCode", reasonCode);
    let reason_code = '';
    if (reasonCode === 'A') {
      reason_code = 'ACCEPTED_STATEMENT_EDI'
    } else {
      reason_code = 'REJECTED_STATEMENT_EDI'
    }
    accountAPI.getEDIMessage(
      statementNo,
      reason_code
    ).then(response => {
      this.setState({ modalOpen: true, ediMessage: response?.data?.eventMessage?.ediMessages })
    })
  }

  getNewAuthStatus = () => {
    this.setState({ fetchLoading: true })
    // console.log(this.props.statementNumber)
    accountAPI.cbpAuthStatus(
      this.props.statementNumber,
      this.props.filerCode
    ).then(response => {
      if (response.data.eventMessage.code && response.data.eventMessage.code === 400) {
        this.setState({ submitted: false, fetchLoading: false, fetchingStatus: false })
      } else if (response.data.eventMessage.statementNumber && !response.data.eventMessage.acceptanceErrorCode) {
        this.setState({ submitted: true, fetchLoading: false, fetchingStatus: false })
      } else if (response.data.eventMessage.acceptanceErrorCode && (response.data.eventMessage.acceptanceErrorCode === "A" || response.data.eventMessage.acceptanceErrorCode === "Q11")) {
        this.setState({ accepted: true, fetchLoading: false, fetchingStatus: false })
      } else if (response.data.eventMessage.acceptanceErrorCode && response.data.eventMessage.acceptanceErrorCode === "R") {
        this.setState({ rejected: true, fetchLoading: false, errorMessage: response.data.eventMessage.acceptanceErrorMessage, fetchingStatus: false })
      }

    })
  }

  formatPrintDate = (date) => {
    return date.split(" ", 1)
  }

  formatMoney = (num) => {
    let value = num && !isEmpty(num) && num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    if (value === 'NaN') {
      value = '0.00'
    }
    return value;
  }

  closeConfirm = () => {
    this.setState({ confirm: false })
  }

  downloadDocument = (bucketName, fileName) => {
    downloadInvoiceSignedUrl(bucketName, fileName)
      .then((res) => {
        let url = get(res, "data.eventMessage.urls[0]", null);
        window.open(url);
      })
      .catch((err) => console.error(err));
  }

  submitClicked = () => {

    this.setState({ confirm: true, responseReceived: false })
    setTimeout(() => {
      if (document.querySelector(".modals.dimmer")) {
        document.querySelector(".modals.dimmer").style.backgroundColor = "rgba(255,255,255,0.4)"
      }
    }, 1000);
    accountAPI.getPUN(this.props.statementNumber)
      .then(response => {
        this.setState({
          tempPunNumber: response.data.eventMessage.punNumber,
          tempPortCode: response.data.eventMessage.portCode,
          tempBusinessName: response.data.eventMessage.businessName,
          tempPunInfo: response.data.eventMessage.punInfo,
          responseReceived: true,
          isACHCredit: response.data.eventMessage.isACHCredit,
          errorCode: response.data.eventMessage.code,
          errorMsg: response.data.eventMessage.msg,
        })
      })
  }


  handleModal = (value) => {
    this.setState({ showUpdateStatementsModal: value })
  }

  handleStatusDetailsModal = (value) => {
    this.setState({ showStatusDetailsModal: value })
  }


  checkClickHandlerRow = (e, actualIndex) => {
    let checkedRows = this.state.selcetedEntriesIndex;


    if (e.target.checked) {
      checkedRows.push(actualIndex);

    } else {
      checkedRows = checkedRows.filter((i) => {
        return i != actualIndex;
      });
    }
    this.setState({ selcetedEntriesIndex: checkedRows });
  };

  headerCheckbox = (e) => {
    let len = this.props.cbpDailyData.statementEntries && this.props.cbpDailyData.statementEntries.length || 0
    let checkedRows = []
    for (let i = 0; i < len; i++) {
      if (e.target.checked && !this.props.cbpDailyData.statementEntries[i].isArchived) {

        checkedRows.push(i);

        document.getElementById(`${i}-rowCheckbox`).checked = true;
      } else {
        // document.getElementById(`${i}-rowCheckbox`).checked=false;
      }
    }



    this.setState({ selcetedEntriesIndex: checkedRows });
  }

  handleArcheiveStatement = async (statementNumber, heading) => {
    accountAPI.archeiveStatement(statementNumber).then(response => {
      if (response.data.eventMessage.code === 200) {
        this.props.removeStamentFromList(statementNumber, heading)
      }
    })
  }


  // handleCheck=(checked,entryNo,entryLength,ind,activeIndex)=>{
  //   let {statementNumber}=this.props
  //   let {isDeleteStatement,statements}=this.state
  //   // let statements=new Map()
  //   if(statements && statements.has(statementNumber)){
  //     statements.get(statementNumber)[ind]=!statements.get(statementNumber)[ind]
  //   }else{
  //     let arr=new Array(entryLength).fill(false)
  //     arr[ind]=!arr[ind]
  //     statements.set(statementNumber,arr)
  //   }
  // }

  // handleDeleteStatementEnteries=()=>{
  //   const { isDeleteStatement }=this.state
  //   if(isDeleteStatement) this.callDeleteStatementApi()
  //   if(!isDeleteStatement) this.setState({ isDeleteStatement:!this.state.isDeleteStatement})
  // }

  // callDeleteStatementApi = () => {
  //   const { statements } = this.state
  //   const { statementNumber, cbpDailyData } = this.props;
  //   const checkedValues = statements.get(statementNumber);
  //   const values = cbpDailyData.statementEntries.reduce((res, e1, i1) => {
  //     checkedValues.map((e2, i2) => {
  //       if(i1 === i2 && e2) res.push(e1.entryNumber)
  //     })
  //     return res;
  //   },[]);
  //   accountAPI.deleteStatementEnteries(statementNumber, values)
  //   .then(response => {
  //       this.props.handleAlertMessage("success", statementNumber, values);
  //   }).catch(err => {
  //       this.props.handleAlertMessage("fail", statementNumber, values);
  //   })
  // }

  // cancelStatement=()=>{
  //   let {isDeleteStatement,statements}=this.state
  //   let {statementNumber}=this.props
  //   if(statements && statements.get(statementNumber)){
  //     let entryLength=statements.get(statementNumber).length
  //     let arr=new Array(entryLength).fill(false)
  //     this.setState({
  //       isDeleteStatement:!isDeleteStatement,
  //       statements:statements.delete(statementNumber),
  //       statements:statements.set(statementNumber,arr)
  //     })
  //   }else{
  //     this.setState({
  //       isDeleteStatement:!isDeleteStatement,
  //     })
  //   }
  // }
  resetCheckBoxIndex = () => {
    this.setState({ selcetedEntriesIndex: [] })
    document.getElementById(`headerCheckbox`).checked = false;
  }





  render() {
    let countOfShipmentsWithoutReleaseDate = 0
    const { activeIndex, submitted, accepted, submitLoading, fetchLoading, otherFees, tempPunNumber, tempPortCode, tempBusinessName, tempPunInfo, isACHCredit, responseReceived, selectEntryNumber, selectedImporter, errorMsg, errorCode } = this.state

    const specialCaseEntryTypeNineNeedsNoReleaseDate = 9;
    const { cbpDailyIndex, cbpDailyData, statementPrintDate, importerName, nonArchiveEntries, fileName, bucketName, statementNumber, authStatus, paymentStatusCode, pun, updateEntriesFromStatement, removeStamentFromList, heading, isBrokerKnAdmin, disabledArchiveButton, isDisabledFromEngine } = this.props

    const collapseStyle = {
      marginLeft: "15px",
      backgroundColor: "white",
      color: "black",
      fontSize: "12px",
      border: "1px solid #1765AE",
      borderRadius: "2px",
      marginRight: "20px",
      height: "20px",
      color: "#1765AE",
      lineHeight: "3px",
      width: "104px",
      lineHeight: "13px",
      padding: "0 4px"
    }
    let disableSubmitBtn = (this.props.hasOwnProperty("nonArchiveEntries") === true) && !isUndefined(this.props.nonArchiveEntries) ? false : true

    const expandStyle = {
      marginLeft: "15px",
      backgroundColor: "white",
      color: "black",
      fontSize: "12px",
      border: "1px solid #1765AE",
      borderRadius: "2px",
      marginRight: "20px",
      height: "20px",
      color: "#1765AE",
      lineHeight: "3px",
      width: "104px",
      lineHeight: "13px",
      padding: "0 4px"
    }


    const authColors = {
      orange: {
        color: '#F7B500'
      },
      green: {
        color: '#90CE4E'
      },
      red: {
        color: 'red'
      },
      white: {
        color: 'white'
      }
    }

    let paymentType = "";
    if (paymentStatusCode.includes("IMPORTER_DAILY"))
      paymentType = "Importer Daily";
    else if (paymentStatusCode.includes("IMPORTER_MONTHLY"))
      paymentType = "Importer Monthly";
    else if (paymentStatusCode.includes("BROKER_DAILY"))
      paymentType = "Broker Daily";
    else if (paymentStatusCode.includes("BROKER_MONTHLY"))
      paymentType = "Broker Monthly";

    const options = [
      { 'key': 0, 'text': 'Authorize', 'value': 'authorize' },
      { 'key': 1, 'text': 'Remove from Statement', 'value': 'remove' }
    ]

    let generateEntryNumberList = (indexList) => {
      const { cbpDailyData } = this.props;
      let data = [];
      indexList.map((x, index) => {
        let obj = {
          entryNumber: cbpDailyData.statementEntries[x].entryNumber,
          paymentStatusCode: cbpDailyData.paymentStatusCode,
          // periodicStatementMonth: "",
          // newStatementPrintDate: "",
          paymentType: "",
        };
        data.push(obj);
      });

      return data;
    };
    // console.log("222222 this.props ::", this.props)
    let archivedLineItem = []
    let validLineItem = []
    return (
      <center>
        <div>
          <StatusDetailModal
            trigger={

              <div style={{ cursor: 'pointer', marginRight: "0 !important", visibility: "hidden" }} className="detailsBtnStatusDetailsModal" id={`${statementNumber}-statusDetailsMOdal`}
                onClick={(e) => {
                  e.stopPropagation()
                  this.handleStatusDetailsModal(true)
                }}
              >  : "",
                :"".
                DETAIL
              </div>

            }
            updateModelOpen={this.state.showStatusDetailsModal}
            handleOpen={() => this.handleStatusDetailsModal(true)}
            handleModalClose={() => this.handleStatusDetailsModal(false)}
            entryNumber={selectEntryNumber}
            statementNumber={statementNumber}
            filerCode={this.props.filerCode}
            importerRecordNumber={selectedImporter}
            getStatementData={this.props.getStatementData}
            toggleModal={this.props.toggleModal}
          />
        </div>
        {/* {this.state.confirm  && <Confirm statementNumber={statementNumber} handleAuthorize={this.handleAuthorize.bind(this)} close={this.closeConfirm.bind(this)} numberOfShipments={cbpDailyData.statementEntries?.length} amountToAuthorize={this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))} tempPunNumber={tempPunNumber} tempPortCode={tempPortCode} tempBusinessName={tempBusinessName} tempPunInfo={tempPunInfo} isACHCredit={isACHCredit} responseReceived={responseReceived} />} */}

        <Segment className='cbpPaymentSection'>
          <Accordion>
            <Accordion.Title style={{ cursor: 'default' }} active={activeIndex === cbpDailyIndex} >
              <div className='cbpPaymentSectionHeaderDiv'>
                <Header className='cbpPaymentSectionHeader' as='h5'>
                  <Button onClick={this.handleClick} style={activeIndex === cbpDailyIndex ? collapseStyle : expandStyle}> <Icon name={activeIndex === cbpDailyIndex ? 'minus' : 'add'} /> {activeIndex === cbpDailyIndex ? 'COLLAPSE' : 'EXPAND'} </Button>
                </Header>
                <div className='headerSectionFour mt4 importerNameCol'>
                  <Header className='cbpHeaderText top' as='h5'>IMPORTER NAME</Header>
                  <Header className='cbpHeaderText importerName' as='h5'>{importerName && formatPronoun(importerName)}</Header>
                </div>

                <div className='headerSectionFour mt4 k84Date'>
                  <Header className='cbpHeaderText top' as='h5'>K84 DATE</Header>
                  <Header className='cbpHeaderText' as='h5'>00/00/0000</Header>
                </div>


                <div className='headerSectionFour mt4'>
                  <Header className='cbpHeaderText top' as='h5'>PUN</Header>
                  <Header className='cbpHeaderText' as='h5'>{pun}</Header>
                </div>
                <div className='headerSectionFour mt4'>
                  <Header className='cbpHeaderText top' as='h5'>STATEMENT NO.</Header>
                  <Header className='cbpHeaderText' as='h5'>{statementNumber}</Header>
                </div>
                <div className='headerSectionFour mt4'>
                  <Header className='cbpHeaderText top' as='h5'>PRINT DATE</Header>
                  <Header className='cbpHeaderText' as='h5'>
                    {convertNumberStringToDate(statementPrintDate)}
                  </Header>
                </div>


                {activeIndex !== cbpDailyIndex ?
                  <div className='headerSectionAuth'>
                    <Header className='cbpHeaderText' as='h5'>
                      {/* <p className='authIconHeader'>
                        {this.state.rejected ?
                          <Icon style={authColors.red} size='large' name='exclamation circle'/>
                          :
                          <Icon.Group>
                            <Icon style={submitted ? authColors.orange : accepted ? authColors.green : authColors.white} size='large' name='circle outline' />
                            <Icon style={submitted ? authColors.orange : accepted ? authColors.green : authColors.white} size='small' name='check' />
                          </Icon.Group>
                        }
                      </p> */}
                    </Header>
                  </div>

                  : null}

                <div className='headerSectionPayer mt4' style={{ top: '20px !important' }}>
                  <Header className='cbpHeaderText top' as='h5'>PAYMENT TYPE</Header>
                  <Header className='cbpHeaderText' as='h5'>{paymentType}</Header>
                </div>


                <div className='headerSectionThree mt4'>
                  <Header className='cbpHeaderText top' as='h5'>PORT OF ENTRY</Header>
                  <Header className='cbpHeaderText' as='h5'>{cbpDailyData.processingPort}</Header>
                </div>

                <div className='headerSectionThree mt4' style={{ width: "10%" }}>
                  <Header className='cbpHeaderText top' as='h5'>FILER CODE</Header>
                  <Header className='cbpHeaderText' as='h5'>{cbpDailyData.filerCode}</Header>
                </div>

                <div className='headerSectionFour authAmountWrapper '>
                  <div className='stmtStatus'>

                    {
                      authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_ACCEPT" &&

                      <Icon className='approvedIcon' name='check circle' size="large" color='green' />
                    }

                    {
                      authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_FAIL_TO_SEND" &&

                      <img src="/images/warning.png" className="warningIcon" />
                    }


                    {
                      authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_REJECT" &&

                      <Popup content={authStatus.acceptanceErrorMessage} trigger={<img src="/images/warning.png" className="warningIcon" />} />
                    }

                    {
                      (authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_SENT" || authStatus.reasonCode === "PAYMENT_AUTH_RESPONSE_NONE") &&

                      <img src="/images/in-progress.png" className="inprogressIcon" />
                    }

                    {
                      (typeof authStatus.reasonCode === "undefined" && authStatus.acceptanceErrorCode === "A") &&

                      <Icon className='approvedIcon' name='check circle' size="large" color='green' />
                    }

                    {
                      (typeof authStatus.reasonCode === "undefined" && authStatus.acceptanceErrorCode === "R") &&

                      <Popup content={authStatus.acceptanceErrorMessage} trigger={<img src="/images/warning.png" className="warningIcon" />} />
                    }

                    {
                      (typeof authStatus.reasonCode === "undefined" && typeof authStatus.acceptanceErrorCode === "undefined") &&

                      <img src="/images/in-progress.png" className="inprogressIcon" />
                    }

                  </div>
                  <Header className='cbpHeaderText authAmount' as='h5'>
                    ${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))}
                  </Header>
                  <div className='cbpHeaderText top' as='h5'>AUTH.<br />AMOUNT</div>

                </div>

                <div class="rightPortion">
                  <div className='headerSectionFour mt4 stmtAmount'>
                    <Header className='cbpHeaderText' as='h5'>C$ 0,000,000</Header>
                  </div>

                  {!isEmpty(fileName) && !isEmpty(bucketName) ?
                    <div className='headerSectionFour meta_icon enabled' onClick={() => this.downloadDocument(bucketName, fileName)} style={{ cursor: "pointer" }}>
                      <span download="report.xml" className='ui header cbpHeaderText top'>
                        <img src="/images/download.png" style={{ color: "red", display: "block", margin: "10px 8px", width: "20px" }} />
                      </span>
                    </div> :
                    <div className='headerSectionFour meta_icon'>
                      <span download="report.xml" className='ui header cbpHeaderText top'>
                        <img src="/images/download_disabled.png" style={{ color: "red", display: "block", margin: "10px 8px", width: "20px" }} />
                      </span>
                    </div>

                  }
                  <div className='headerPrint meta_icon enabled'>
                    <ReactToPrint
                      trigger={() => <Icon color="specialBlue" style={{ cursor: 'pointer', marginRight: "0 !important" }} className='paymentPrint' name='print' />}
                      content={() => this.componentRef}
                    />
                  </div>
                  <div className={`headerPrint aaaaaaaa meta_icon enabled`} style={{ marginLeft: "10px" }}
                    title={this.state.selcetedEntriesIndex.length > 0 ? '' : ' Select a entry in the expanded view to edit '}>
                    <UpdateStatementsModal

                      key='mockPrt-modal-button'
                      trigger={
                        <Icon color="specialBlue" style={{ cursor: 'pointer', marginRight: "0 !important" }}
                          disabled={!(this.state.selcetedEntriesIndex.length > 0) || isBrokerKnAdmin === true || isDisabledFromEngine ? true : false}
                          className='paymentPrint' name='edit'
                          onClick={(e) => {
                            e.stopPropagation()
                            this.state.selcetedEntriesIndex.length > 0 && this.handleModal(true)
                          }}
                        />
                      }
                      updateModelOpen={this.state.showUpdateStatementsModal}
                      defaultPaymentType1={authStatus && authStatus.hasOwnProperty("acceptanceErrorCode") && authStatus.acceptanceErrorCode === "A" ? true : false}
                      selectedEntriesCount={this.state.selcetedEntriesIndex.length}
                      handleOpen={() => this.handleModal(true)}
                      handleModalClose={() => this.handleModal(false)}
                      entryNumberJson={generateEntryNumberList(this.state.selcetedEntriesIndex)}
                      statementNumber={statementNumber}
                      filerCode={this.props.filerCode}
                      updateEntriesFromStatement={updateEntriesFromStatement}
                      resetCheckBoxIndex={this.resetCheckBoxIndex}
                      heading={heading}
                      statementPrintDate={statementPrintDate}
                      dateAccepted={authStatus?.dateAccepted}
                      accepted={this.state.accepted ? 'accepted' : 'notAccepted'}
                    />



                  </div>
                </div>
              </div>
            </Accordion.Title>

            <Accordion.Content active={activeIndex === cbpDailyIndex} >
              <hr />
              <Table basic='very' selectable>
                <Table.Header>
                  <Table.Row>
                    {/* { authStatus.reasonCode !== "PAYMENT_AUTH_RESPONSE_ACCEPT" && isDeleteStatement  && <Table.HeaderCell></Table.HeaderCell>}  */}
                    <Table.HeaderCell><label className="greebCheckbox" style={{ marginLeft: "-3px" }}> <input
                      type="checkbox"
                      id="headerCheckbox"
                      onClick={(e) => {
                        this.headerCheckbox(e)
                      }}
                      disabled={isDisabledFromEngine}
                    />
                      <span className="checkmark"></span>
                    </label></Table.HeaderCell>

                    <Table.HeaderCell>{this.props.isEngine ? `TRANSACTION ID` : `SHIPMENT ID`}</Table.HeaderCell>
                    {
                      this.props.isEngine && <Table.HeaderCell>{`SHIPMENT(S)`}</Table.HeaderCell>
                    }
                    <Table.HeaderCell><span title="Entry Type">TYPE</span></Table.HeaderCell>
                    <Table.HeaderCell>ENTRY #</Table.HeaderCell>
                    <Table.HeaderCell>IMPORTER</Table.HeaderCell>
                    <Table.HeaderCell>PO</Table.HeaderCell>
                    <Table.HeaderCell>RELEASE DATE</Table.HeaderCell>
                    {(paymentStatusCode === "PAYMENT_STATEMENT_CODE_BROKER_MONTHLY" || paymentStatusCode === "PAYMENT_STATEMENT_CODE_IMPORTER_MONTHLY_WITH_SUFFIX") && <Table.HeaderCell>PAYMENT MONTH</Table.HeaderCell>}
                    <Table.HeaderCell textAlign='right'>DUTIES</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>TAXES</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>ADD</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>CVD</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>OTHER FEES</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>TOTAL</Table.HeaderCell>
                    <Table.HeaderCell textAlign='right'>UPDATE STATUS</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {

                    cbpDailyData.statementEntries ? cbpDailyData.statementEntries.map((item, i) => {
                      let popmsg = ''
                      let shipmentReleaseDate = null;

                      let other_fee = !isNull(item.feesTotal) && !isUndefined(item.feesTotal) ? (parseFloat(item.feesTotal) / 100).toFixed(2) : 0;
                      let hasReleaseDateOrEntryTypeNine = (((item.entryUpdateResp.hasOwnProperty("shipmentReleaseDate") && item.entryUpdateResp.shipmentReleaseDate)) || parseInt(item.entryType) == specialCaseEntryTypeNineNeedsNoReleaseDate);
                      if (!get(item, 'isArchived', false) && item.hasOwnProperty("entryUpdateResp") && hasReleaseDateOrEntryTypeNine) {
                        shipmentReleaseDate = new Date(item.entryUpdateResp.shipmentReleaseDate);


                        validLineItem.push(item)
                      } else {
                        if (get(item, 'isArchived', false))
                          archivedLineItem.push(item)
                      }


                      const isMonthlyShipment = (paymentStatusCode === "PAYMENT_STATEMENT_CODE_BROKER_MONTHLY" || paymentStatusCode === "PAYMENT_STATEMENT_CODE_IMPORTER_MONTHLY_WITH_SUFFIX");



                      let entryTypeNine = parseInt(item.entryType) == specialCaseEntryTypeNineNeedsNoReleaseDate;
                      if (shipmentReleaseDate && !entryTypeNine && isMonthlyShipment) {
                        let periodicMonth = item.entryUpdateResp.periodicStatementMonth;
                        let dateOfPeriodicStatement = (shipmentReleaseDate.getFullYear() + (periodicMonth == 1 ? 1 : 0)) + '/' + periodicMonth + '/1';
                        let diffDate = this.getMonthDifference(shipmentReleaseDate, new Date(dateOfPeriodicStatement));
                        if (diffDate >= 2) {
                          popmsg = 'You are trying to authorize statement where Payment Month is more than one month from Release Date, please check';
                        }
                        if (diffDate < 0) {
                          popmsg = 'You are trying to authorize statement where Payment Month is more than one month from and possibly before Release Date, please check';
                        }


                        if (diffDate == 0) {
                          popmsg = 'You are trying to authorize statement where Payment Month is the same month as Release Date, please check';
                        }
                      }

                      if (!item.entryUpdateResp.shipmentReleaseDate && !entryTypeNine) {
                        popmsg = 'You are trying to authorize statement that has one or more entries without Release Date';
                      }
                      return (
                        <Table.Row style={{ cursor: 'pointer' }} onClick={this.props.open} disabled={this.state.i} className={item && item.isArchived === true ? "empty" : ""} id={i}>
                          <Table.Cell style={{ "display": "flex", "justify-content": "space-between" }}>    {this.state.selcetedEntriesIndex.indexOf(i) ===
                            -1 ? (
                            (item.hasOwnProperty("isArchived") === false || item.isArchived === false) &&
                            <label className="greebCheckbox">
                              <input
                                type="checkbox"
                                id={`${i}-rowCheckbox`}
                                onClick={(e) => {
                                  this.checkClickHandlerRow(e, i);
                                }}
                                disabled={((item && item.hasOwnProperty("isArchived") === true && item.isArchived === true)||isDisabledFromEngine) ? true : false}
                              />
                              <span className="checkmark"></span>
                            </label>
                          ) : ((item.hasOwnProperty("isArchived") === false || item.isArchived === false) &&
                            <label className="greebCheckbox">
                              <input
                                type="checkbox"
                                id={`${i}-rowCheckbox`}
                                onClick={(e) => {
                                  this.checkClickHandlerRow(e, i);
                                }}
                                checked
                                disabled={item && item.hasOwnProperty("isArchived") === true && item.isArchived === true ? true : false}
                              />
                              <span className="checkmark"></span>
                            </label>
                          )}
                            {Boolean(popmsg && this.state.countryOfBusiness === 'UNITED_STATES' && !this.state.submitted && !item.isArchived && !this.state.accepted) &&
                              <Popup content={popmsg} trigger={<Icon name="warning sign" color="red" />} basic />
                            }

                          </Table.Cell>
                          <Table.Cell>{item.transactionId || item.shipmentId}</Table.Cell>
                          {
                            this.props.isEngine && <Table.Cell>{item.shipmentIdList ? item.shipmentIdList?.join(", ") : item.shipmentId}</Table.Cell>
                          }
                          <Table.Cell>{(item.entryType + "").padStart(2, '0')} </Table.Cell>
                          <Table.Cell>{this.props.filerCode + '-' + item.entryNumber}</Table.Cell>
                          <Table.Cell>{item.importerName}</Table.Cell>
                          <Table.Cell>{item.poNumber}</Table.Cell>
                          <Table.Cell>{item.hasOwnProperty("entryUpdateResp") && item.entryUpdateResp.hasOwnProperty("shipmentReleaseDate") && item.entryUpdateResp.shipmentReleaseDate || ""}</Table.Cell>
                          {(paymentStatusCode === "PAYMENT_STATEMENT_CODE_BROKER_MONTHLY" || paymentStatusCode === "PAYMENT_STATEMENT_CODE_IMPORTER_MONTHLY_WITH_SUFFIX") && <Table.Cell>{item.hasOwnProperty("entryUpdateResp") && item.entryUpdateResp.hasOwnProperty("periodicStatementMonth") && item.entryUpdateResp.periodicStatementMonth || ""}</Table.Cell>}
                          <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.dutyAmount) / 100).toFixed(2))}</Table.Cell>
                          <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.taxAmount) / 100).toFixed(2))}</Table.Cell>
                          <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.ADD) / 100).toFixed(2))}</Table.Cell>
                          <Table.Cell textAlign='right'>${this.formatMoney((parseFloat(item.CVD) / 100).toFixed(2))}</Table.Cell>
                          <Popup
                            size='tiny'
                            trigger={<Table.Cell textAlign='right'>
                              {!isNull(item.feesTotal) && !isUndefined(item.feesTotal) ? `$${(parseFloat(item.feesTotal) / 100).toFixed(2)}` : "$0.00"}
                            </Table.Cell>}
                            header='OTHER FEES'
                            on={['hover', 'click']}
                          >
                            <center><p className='feePopupHeader'>OTHER FEES</p></center>
                            <br />
                            <Grid columns={2}>
                              {item.fees && item.fees.map((fee, i) => (
                                <Grid.Row>
                                  <Grid.Column style={{ width: '70%' }}>
                                    <p className='cbpOtherFeeLabel'>
                                      {fee.key}
                                    </p>
                                  </Grid.Column>
                                  <Grid.Column style={{ width: '20%' }}>
                                    <p className='cbpOtherFeeValue'>${this.formatMoney(parseFloat(fee.value / 100).toFixed(2))}</p>
                                  </Grid.Column>
                                </Grid.Row>
                              ))}
                            </Grid>

                          </Popup>
                          <Table.Cell textAlign='right'>${this.formatMoney(this.formatTotal(item.dutyAmount, item.taxAmount, item.ADD, item.CVD, other_fee))}</Table.Cell>
                          <Table.Cell textAlign='right'>

                            <a href="javascript:;" onClick={() => {
                              this.setState({ selectedImporter: item.importerRecordNumber, selectEntryNumber: item.entryNumber })
                              document.getElementById(`${statementNumber}-statusDetailsMOdal`).click()
                            }}>  {item.hasOwnProperty("entryUpdateResp") && item.entryUpdateResp.hasOwnProperty("status") && item.entryUpdateResp.status === "ACCEPTED" ? <Icon className='approvedIcon' name='check circle' size="large" color='green' />
                              : item.hasOwnProperty("entryUpdateResp") && item.entryUpdateResp.hasOwnProperty("status") && item.entryUpdateResp.status === "REJECTED" ? <img src="/images/warning.png" className="warningIcon" style={{ width: "18px" }} /> : null}
                              {item.hasOwnProperty("entryUpdateResp") && item.entryUpdateResp.hasOwnProperty("status") && (item.entryUpdateResp.status === "ACCEPTED" || item.entryUpdateResp.status === "REJECTED") ? "DETAIL" :
                                item.hasOwnProperty("entryUpdateResp") && item.entryUpdateResp.hasOwnProperty("status") && (item.entryUpdateResp.status === "SENT") ? "PROCESSING" :
                                  item.hasOwnProperty("entryUpdateResp") &&
                                    item.entryUpdateResp.hasOwnProperty("status") ? item.entryUpdateResp.status : null} </a>

                          </Table.Cell>
                        </Table.Row>

                      )
                    }) : null}
                </Table.Body>
              </Table>
              <br /><br /><br />
              <div className="cbpPaymentButtonRow">
                {disableSubmitBtn &&
                  <Button type='submit' id="archeive" onClick={(e) => {
                    e.stopPropagation()
                    this.handleArcheiveStatement(statementNumber, heading)
                  }}
                    style={{
                      float: "left",
                      marginLeft: "3%", height: "50px",
                      width: "20%"
                    }}
                    disabled={isBrokerKnAdmin === true ? true : disabledArchiveButton === true ? true : false}
                    color="twitter">ARCHIVE
                  </Button>}
                {this.state.rejected ?
                  <div className='authMessage'>
                    <Popup content={<p style={{ color: 'red' }}>Error code: {this.state.errorMessage}</p>}
                      trigger={<p className='authIcon'>
                        <Icon style={{ color: 'red', cursor: 'pointer' }} size='large' name='exclamation circle' />
                      </p>} />
                    <p className='authText'>
                      Authorization Rejected
                    </p>
                    <Icon loading={submitLoading} onClick={this.submitClicked} style={{ color: '#007BFF', cursor: 'pointer' }}
                      size='large' name='redo alternate' />
                  </div>

                  :

                  this.state.submitted && !this.state.submissionErr ?
                    <>
                      {/* TO DO: <div onClick={() => { this.setState({ submitted: false }) }} className='authReversal'>
                      <p className='authIcon'>
                        <Icon.Group>
                          <Icon style={{ color: '#BCBCBC' }} size='small' name='undo' />
                        </Icon.Group>
                      </p>
                      <p style={{ color: '#BCBCBC' }} className='authText'>
                        UNDO AUTHORIZATION
                                </p>
                    </div> */}
                      <div className='authMessage auth-message'>
                        <p className='authIcon'>
                          <Icon.Group>
                            <Icon style={{ color: '#F7B500' }} size='large' name='circle outline' />
                            <Icon style={{ color: '#F7B500' }} size='small' name='check' />
                          </Icon.Group>
                        </p>
                        <p className='authText'>
                          {this.state.fetchingStatus ?

                            <p className='cbp-fetch'>Awaiting CBP Response</p>

                            :

                            "Authorization Transmitted"

                          }
                        </p>
                      </div>
                    </>
                    : this.state.accepted ?
                      <div className='authMessage'>
                        <p className='authIcon'>
                          <Icon.Group>
                            <Icon style={{ color: '#90CE4E' }} size='large' name='circle outline' />
                            <Icon style={{ color: '#90CE4E' }} size='small' name='check' />
                          </Icon.Group>
                        </p>
                        <p className='authText'>
                          Authorization Accepted
                        </p>
                      </div>
                      : this.state.submissionErr ?
                        <div className='authMessage'>
                          <p className='authIcon'>
                            <Icon.Group>
                              <Icon style={{ color: 'red' }} size='large' name='exclamation' />
                            </Icon.Group>
                          </p>
                          <p className='authText'>
                            Error sending request
                          </p>
                          <Icon loading={submitLoading} onClick={() => this.handleAuthorize()}
                            style={{ color: '#007BFF', cursor: 'pointer' }} size='large' name='redo alternate' />
                        </div>
                        :
                        <div>

                          <span style={{ display: 'none' }} >
                            {countOfShipmentsWithoutReleaseDate = (get(cbpDailyData, 'statementEntries', []).filter(aaaa =>
                              parseInt(aaaa.entryType) != specialCaseEntryTypeNineNeedsNoReleaseDate && !aaaa?.entryUpdateResp?.shipmentReleaseDate && !aaaa.isArchived

                            ).length)}
                          </span>
                          {countOfShipmentsWithoutReleaseDate ?

                            <Message
                              warning
                              content={`You are trying to authorize statement that has ${countOfShipmentsWithoutReleaseDate} entr${countOfShipmentsWithoutReleaseDate == 1 ? 'y' : 'ies'} without Release Date`}
                            />
                            :
                            <Button onClick={() => this.submitClicked()} type='submit'
                              disabled={isBrokerKnAdmin === true ? true : disableSubmitBtn}
                              className="cbpTableAuth" color="twitter">SUBMIT
                              <span style={{ backgroundColor: "rgb(0, 123, 255)", color: "white", borderRadius: "10px", padding: "4px 7px 5px", fontSize: '10px' }}>{(nonArchiveEntries) ? nonArchiveEntries : 0}</span></Button>
                          }

                          {this.state.statementConfirmModal && <StatementModal validLineItem={validLineItem || []} archivedLineItem={archivedLineItem || []} changeStateModal={this.changeStateModal} statementConfirmModal={this.state.statementConfirmModal} submitClicked={this.submitClicked} />}

                        </div>

                }
                {/* {nonArchiveEntries && authStatus.reasonCode !== "PAYMENT_AUTH_RESPONSE_ACCEPT" && <button className={(isDeleteStatement)?"delete_statement_btn_selected":"delete_statement_btn"} onClick={this.handleDeleteStatementEnteries} >{(isDeleteStatement)?"DELETE SELECTED ENTRY(S)":"DELETE ENTRY(S)"}</button> } 
                 {authStatus.reasonCode !== "PAYMENT_AUTH_RESPONSE_ACCEPT" && isDeleteStatement &&<button className="delete_statement_btn_selected" onClick={this.cancelStatement} >CANCEL</button> }  */}


                <div className='buttonRowTextDiv'>
                  <p className='buttonRowText buttonRowLabel'>TOTAL</p>
                  <p className='buttonRowText buttonRowTotal'>${this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))}</p>
                </div>
                {(authStatus.acceptanceErrorCode === 'A' || authStatus.acceptanceErrorCode === 'R') &&
                  <div className='ckeckEdiResponse'>
                    <button className="checkEdiResponse_selected" onClick={() => this.ediResponse(statementNumber, authStatus.acceptanceErrorCode)} >Check EDI Response</button>
                  </div>
                }
                <EdiModal
                  key='edimodal'
                  modalOpen={this.state.modalOpen}
                  ediMessage={this.state.ediMessage}
                  statementNumber={statementNumber}
                  handleClose={
                    () => {
                      this.setState({ modalOpen: false })
                    }
                  }
                />
              </div>
            </Accordion.Content>
          </Accordion>
        </Segment>
        {this.state.confirm && <Confirm statementNumber={statementNumber} handleAuthorize={this.handleAuthorize.bind(this)} close={this.closeConfirm.bind(this)} numberOfShipments={validLineItem?.length} amountToAuthorize={this.formatMoney((parseFloat(cbpDailyData.totalAmountDue) / 100).toFixed(2))} tempPunNumber={tempPunNumber} tempPortCode={tempPortCode} tempBusinessName={tempBusinessName} tempPunInfo={tempPunInfo} isACHCredit={isACHCredit} responseReceived={responseReceived} errorCode={errorCode} errorMsg={errorMsg}/>}
        <div className='printStatement' style={{ display: 'none' }}>
          <PrintDaily 
            ref={el => (this.componentRef = el)} 
            importerNumber={this.props.importerNumber} 
            key={this.props?.key} 
            cbpDailyIndex={this.props.cbpDailyIndex} 
            cbpDailyData={this.props.cbpDailyData} 
            open={this.props.open} 
            pun={pun} 
          />
        </div>
      </center>
    )
  }
}

export default PreDailyStatement;
